// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + ({"12":"profiler","777":"recorder"}[chunkId] || chunkId) + "." + {"12":"e337b81c","72":"ed8c7029","198":"902f896f","477":"3affb2c5","627":"958f0f9d","663":"3bad9a4d","777":"bbf341a0","803":"16517f9d","820":"24a930ac"}[chunkId] + ".chunk.js";
};